import React, { useState } from "react";
import MDBox from "components/MDBox";
import { Card, Tab, Tabs } from "@mui/material";
import GerarRemessa from "./tabs/GerarRemessa";
import ImportarRetorno from "./tabs/ImportarRetorno";
import { useMaterialUIController } from "context";

function CnabSystem() {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const [tabValue, setTabValue] = useState(0);

    const handleSetTabValue = (event, newValue) => setTabValue(newValue);

    return (
        <Card id="cnab-info" sx={{ background: darkMode ? "#4B4F5C" : "#fafafa" }}>
            <MDBox sx={{ width: '100%', px: 3, mb: 3, pt: 2 }}>
                <MDBox sx={{ borderBottom: 1, width: "100%", borderColor: darkMode ? "rgba(255, 255, 255, 0.2)" : 'divider' }}>
                    <Tabs 
                        value={tabValue} 
                        onChange={handleSetTabValue} 
                        aria-label="cnab tabs"
                        textColor={darkMode ? "inherit" : "primary"}
                        indicatorColor="info"
                    >
                        <Tab label="Gerar Remessa" sx={{ fontSize: 12, color: darkMode ? (tabValue === 0 ? "#fff" : "rgba(255, 255, 255, 0.7)") : "inherit" }} />
                        <Tab label="Importar Retorno" sx={{ fontSize: 12, color: darkMode ? (tabValue === 1 ? "#fff" : "rgba(255, 255, 255, 0.7)") : "inherit" }} />
                    </Tabs>
                </MDBox>
            </MDBox>
            
            <MDBox px={3} pb={3}>
                <div role="tabpanel" hidden={tabValue !== 0}>
                    {tabValue === 0 && <GerarRemessa />}
                </div>
                <div role="tabpanel" hidden={tabValue !== 1}>
                    {tabValue === 1 && <ImportarRetorno />}
                </div>
            </MDBox>
        </Card>
    );
}

export default CnabSystem;
